import React from 'react';
import { Redirect as ReactRouterRedirect } from 'react-router-dom';
import { RouterSubscriber as LinkListenerDI, Redirect } from '@atlassian/react-resource-router';

type Props = {
	to: string;
	push: boolean;
	RouterSubscriber: typeof LinkListenerDI;
};

const ServicedeskSpaRedirect = (props: Props) => {
	const { RouterSubscriber, to, push } = props;
	const path = to.charAt(0) === '/' ? to : `/${to}`;
	return __SPA__ ? (
		<RouterSubscriber>
			{({ match }) =>
				match && match.params && match.params.projectKey ? (
					<Redirect
						push={push}
						to={`/jira/servicedesk/projects/${match.params.projectKey}${path}`}
					/>
				) : null
			}
		</RouterSubscriber>
	) : (
		<ReactRouterRedirect to={to} push={push} />
	);
};

ServicedeskSpaRedirect.defaultProps = {
	push: false,
	RouterSubscriber: LinkListenerDI,
};

export default ServicedeskSpaRedirect;
